import React from 'react'
import { useTranslation } from 'contexts/Localization'
import { Box, Text } from 'vvs-uikit'
import boostPools from 'config/constants/boostPools'
import LockingPeriodRow from './LockingPeriodRow'

interface SelectPeriodStepProps {
  onSelect: (pid: number) => void
}

const poolInfo = boostPools

const SelectPeriodStep = ({ onSelect }: SelectPeriodStepProps) => {
  const { t } = useTranslation()
  return (
    <Box mb={5}>
      <Text color="textSubtle" maxWidth={550} textAlign="center" style={{ padding: '0 24px 30px' }}>
        {t(
          'Your deposit will be held for the duration of the locking period. After the period ends you will be able to withdraw your funds.',
        )}
      </Text>
      {poolInfo.map((pool) => (
        <LockingPeriodRow {...pool} onSelect={() => onSelect(pool.pid)} key={pool.pid} />
      ))}
    </Box>
  )
}

export default SelectPeriodStep
